import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useGetFinanceOperationsByIdQuery } from 'entities/financeOperations/api/getFinanceOperatorsApi';
import { useParams } from 'react-router-dom';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { FinanceOperationsDetailInfo } from 'widgets/financeOperations/ui/FinanceOperatonsDetailInfo';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';
import { UploadFinanceOperationsForm } from 'entities/financeOperations';
import { DrawerFinanceOperations } from 'widgets/financeOperations';

export const FinanceOperationsDetailPage = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const { id } = useParams();
  const [drawerVariant, setDrawerVariant] = useState('default');

  const { data: detailData, isSuccess } = useGetFinanceOperationsByIdQuery({ id });

  useEffect(() => {
    if (!isDrawerOpen) {
      setDrawerVariant('default');
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    dispatch(setHeaderTitle(detailData?.withdrawal_service.service || ''));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [detailData]);

  if (!isSuccess) {
    return <CircularLoader />;
  }

  return (
    <>
      <FinanceOperationsDetailInfo
        data={detailData}
        drawerVariant={drawerVariant}
        setDrawerVariant={setDrawerVariant}
      />
      {drawerVariant === 'default' && (
        <DrawerFinanceOperations title="Редактировать">
          <UploadFinanceOperationsForm data={detailData} />
        </DrawerFinanceOperations>
      )}
    </>
  );
};
